document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('section[data-section-id]');
      if (!section) return;

      const player = section.querySelector('[data-video-player]');
      if (!player) return;

      trigger.style.display = 'none';
      trigger.classList.add('hidden');

      player.style.display = 'block';
      player.style.visibility = 'visible';
      player.style.opacity = '1';
      player.style.height = 'auto';
      player.style.minHeight = '1px';
      player.classList.remove('hidden');

      const videoEl = player.querySelector('video');
      if (videoEl) {
        videoEl.muted = false;
        videoEl.play().catch(() => {});
        return;
      }

      const iframe = player.querySelector('iframe');
      if (iframe) {
        let src = iframe.dataset.src || iframe.src;
        if (!src) return;
        src = src.replace(/autoplay=[01]&?|mute=[01]&?/g, '').replace(/[?&]$/, '');
        const separator = src.includes('?') ? '&' : '?';
        iframe.src = `${src}${separator}autoplay=1&mute=1&playsinline=1`;
      }
    });
  });

  const handleResponsiveElements = () => {
    const isDesktop = window.innerWidth >= 768;

    document.querySelectorAll('.review-badge').forEach(badge => {
      const section = badge.closest('section[data-section-id]');
      if (!section) return;

      const targetContainer = section.querySelector('.image-with-text--content--inner');
      if (targetContainer && isDesktop) {
        targetContainer.appendChild(badge);
      }
    });

    document.querySelectorAll('.section-text-image.is-boxed').forEach(section => {
      const button = section.querySelector('.button');
      const targetImage = section.querySelector('.image-with-text--image');
      const textContent = section.querySelector('.image-with-text--content--inner');

      if (!button || !targetImage || !textContent) return;

      if (!isDesktop) {
        targetImage.appendChild(button);
        button.classList.add('button--absolute');
      } else {
        textContent.appendChild(button);
        button.classList.remove('button--absolute');
      }
    });
  };

  handleResponsiveElements();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResponsiveElements, 100);
  });
});